export default {
    'SCHOOL_ALREADY_ADDED': 'This school is already added',
    'WRONG_HASH': 'Your unique link is invalid',
    'MISSING_HASH': 'Missing unique link code',
    'NOT_LOGGED_IN': "You're not logged in"
}